module.exports = __webpack_public_path__ + "static/Hassan Jasim.c593bac9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Hassan Jasim.jpg
// module id = 1214
// module chunks = 6166952557895